import $ from 'jquery';

export default (container = document) => {
  $('[data-rte-full-caption]', container).each((i, caption) => {
    const $caption = $(caption);
    const img_src = $caption.data('imgSrc');
    const shoppable_items = $caption.data('shoppable');
    const content = $caption.html();
    let shoppable_data = '';

    if (shoppable_items) {
      shoppable_data = `data-shoppable="${shoppable_items}"`;
    }

    let newHTML = `
    <div class="RteFullCaption">
      <div class="RteFullCaption__container">
        <div class="RteFullCaption__image-wrapper">
          <img class="RteFullCaption__image" onload="elementLoaded(this);" src="${img_src}" ${shoppable_data}>
        </div>
        ${content ? `<div class="RteFullCaption__description">${content}</div>` : ''}
      </div>
    </div>
    `;

    if ($caption.siblings().length !== 1) {
      newHTML = `
        <section class="Section Section--fixed Section--mobile-full AnimateOnLoad Animate--slide-up">
          <div class="Section__container">
            ${newHTML}
          </div>
        </section>
      `;
    }

    $caption.replaceWith(newHTML);
  });
};